import { ObjectHelper } from '../../../../../../apps/idl/src/helpers/objectHelper';
import { StringHelper } from '../../../../../../apps/idl/src/helpers/stringHelper';

export class UnzipError extends Error {

	constructor(psMessage?: string) {
		super(`Erreur lors du dézippage.${StringHelper.isBlank(psMessage) ? "" : ` ${psMessage}`}`);
		// Nécessaire pour que le 'instanceof UnzipError' fonctionne (fonctionne sans uniquement sur le tsPlayground).
		ObjectHelper.initInstanceOf(this, UnzipError);
	}

}